import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShouldSendGlDialogComponent } from './should-send-gl-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [ShouldSendGlDialogComponent],
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  entryComponents: [ShouldSendGlDialogComponent]
})
export class ShouldSendGlDialogModule {}
